import { render, staticRenderFns } from "./AppTour.vue?vue&type=template&id=406b709a&scoped=true"
import script from "./AppTour.vue?vue&type=script&lang=js"
export * from "./AppTour.vue?vue&type=script&lang=js"
import style0 from "./AppTour.vue?vue&type=style&index=0&id=406b709a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b709a",
  null
  
)

export default component.exports